import styled from 'styled-components/macro';

const Role = styled.li`
  color: #fff;
  font-size: 14px;
  opacity: 0.6;

  &:not(:last-of-type)::after {
    content: ',\\00a0';
  }
`;

export default Role;
